// 알리는 길 — 사람에게 흘리는 한 마디의 계약이다 (084 ①).
//
// `Ask` 와 같은 길로 호스트가 콜백을 끼우는데, 다른 점이 하나 있다: **안 끼우면 core 의 기본
// toast 가 선다** (`Ask` 는 기본 침묵이다). editor 층은 DOM 을 모르므로 그 기본 그릇의 몸은
// `ui/toast.ts` 에 있고, 그릇이 인스턴스에 스스로 서는 문(`Nabi.$bindToast`)이 그 배선이다 —
// 호스트 콜백이 있으면 그쪽이 이기고, 없으면 그릇, 그것도 없으면(머리 없는 환경) 침묵.

// 셋뿐이다 — 성공·실패 같은 결과가 아니라 **읽는 사람이 얼마나 긴장해야 하는가**의 눈금이다.
export type ToastLevel = 'info' | 'warn' | 'error';

// 부르는 쪽이 시간을 얹을 수 있다(`ms`) — 안 얹으면 기본(1초, `NabiOptions.toastMs`)이다.
// 긴 안내 한 번을 위해 전체 기본을 늘리지 않게, 시간이 말과 함께 실린다 (084 ask ①).
export type Toast = (level: ToastLevel, message: string, ms?: number) => void;

// 기본 1초 — 주인 결정(084 ask ①). 짧은 확인("복사했다" 류)이 기본이고, 읽어야 하는 말은
// 부르는 쪽이 제 시간을 얹는 쪽으로 갈랐다.
export const TOAST_MS = 1000;

// 동시에 서는 상한 — 넘치면 남은 시간이 가장 적은 것부터 걷는다 (084 ask ① 재답).
// 셋이면 "지금 무슨 일이 있었나"가 다 읽히고, 그보다 많으면 화면이 알림판이 된다.
export const TOAST_MAX = 3;
